import React from 'react';
import { Card, CardContent, Typography, Grid } from '@material-ui/core';
import CountUp from 'react-countup';
import cx from 'classnames';


import { ICovidStatCountry as State } from "../../../types/common";
import styles from './Cards.module.css';

interface Data{
  data?: State
}

const Cards: React.FC<Data> = ({ data }) => {
    
    let content;

      if(!data){
        content = ("Loading...")
      }
      else{
          const {confirmed, lastUpdate, deaths, recovered} = data;
          content = (<Grid container spacing={3} justify="center">
          <Grid item xs={12} md={3} component={Card} className={cx(styles.card, styles.infected)}>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Infected
              </Typography>
              <Typography variant="h5" component="h2">
                <CountUp start={0} end={confirmed.value} duration={2.75} separator="," />
              </Typography>
              <Typography color="textSecondary">
                {new Date(lastUpdate).toDateString()}
              </Typography>
              <Typography variant="body2" component="p">
                Number of active cases of COVID-19.
              </Typography>
            </CardContent>
          </Grid>
          <Grid item xs={12} md={3} component={Card} className={cx(styles.card, styles.recovered)}>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Recovered
              </Typography>
              <Typography variant="h5" component="h2">
                <CountUp start={0} end={recovered.value} duration={2.75} separator="," />
              </Typography>
              <Typography color="textSecondary">
                {new Date(lastUpdate).toDateString()}
              </Typography>
              <Typography variant="body2" component="p">
                Number of recoveries from COVID-19.
              </Typography>
            </CardContent>
          </Grid>
          <Grid item xs={12} md={3} component={Card} className={cx(styles.card, styles.deaths)}>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                Deaths
              </Typography>
              <Typography variant="h5" component="h2">
                <CountUp start={0} end={deaths.value} duration={2.75} separator="," />
              </Typography>
              <Typography color="textSecondary">
                {new Date(lastUpdate).toDateString()}
              </Typography>
              <Typography variant="body2" component="p">
                Number of deaths caused by COVID-19.
              </Typography>
            </CardContent>
          </Grid>
        </Grid>)
      }
    
      return (
        <div className={styles.container}>
          {content}
        </div>
  );
};
export default Cards;